"use strict";

import CardView from "/js/card-views/card-view.js";

/**
 * Card with an unrecognized or unsupported layout type.
 */
export default class UnsupportedCardView extends CardView {
  makeContent() {
    clw('WARNING: Will add card with unsupported layout: ', this.data.layout);
    return "<div class='fpo'>" + "card type: " + this.data.layout + "</div>";
  }
}
